import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import CircularProgress from '@material-ui/core/CircularProgress';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Input from '@material-ui/core/Input';
import PropTypes from "prop-types";
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';
import InputLabel from '@material-ui/core/InputLabel';
import CardActions from '@material-ui/core/CardActions';

const styles = theme => ({
    root: {
        width: '95%',
        minWidth: '150px',
        height: '500px',
        minHeight: '350px',
        //overflowX: 'auto',
        //display: 'column',
        alignItem: 'center',
        margin: '0 Auto',
    },
    formControl: {
        margin: theme.spacing.unit * 3,
    },
    group:{
    },
    radio: {
        '&$checked' : {
            color: '#B71C1C',
        },
    },
    checked: {},
    progress: {
        /*display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItem: 'center',*/
        flexDirection: 'column',
        margin: theme.spacing.unit * 3,
    },
    button:{
        display:'flex',
        //justifyContent: 'center',
        margin: '0 Auto',
    },
    InputLabel:{
        fontSize: '14px',
    },
    rightInput:{
        marginLeft: '50px',
    },
    country:{
        marginTop: '15px',
        marginBottom: '10px',
    },
    hkidPassport:{
        marginTop: '15px',
        marginBottom: '10px',
    },
});

class ForgetPasswordForm extends Component {
    state = {
      email: null,
      pressed:false,
    };

    componentDidMount(){
        //this.props.onUserInfoRef(this);
        this.setState({
            currentPassword: this.props.password,
        });
        this.props.resetRecoverPassword();
        // setInterval(()=>{
            // console.log('The recoverPassword is : '+this.props.recoverPassword_);
        // },1000)
    }
    componentWillUnmount() {
        //this.props.onUserInfoRef(undefined);
      }

    handleChange = prop => event => {
        this.setState({ [prop]: event.target.value });
    }
    
    submitHandler = (event) => {
        event.preventDefault();
        this.props.recoverPassword(this.state.email);
    };

    render(){
        const { classes } = this.props;
        return(
            <form className={classes.root} onSubmit={this.submitHandler}>
                <Card className={classes.card}>
                    <CardContent>
                    <FormControl className={classes.margin} required fullWidth>
                    <label style={{ fontSize: '14px'}} >{this.context.t("Forgot Password")}</label>
                    <label style={{ fontSize: '12px'}} >{this.context.t("Please enter the username of your account. An email will be sent to your email address for recovery.")}</label>
                    {/* { this.props.recoverPassword_ && <label style={{ fontSize: '12px'}} > If username is registered, an email has been sent for password recovery.</label> } */}
                    </FormControl>
                        <FormControl className={classes.margin} required fullWidth>
                        
                            <InputLabel style={{ fontSize: '14px'}} htmlFor="current-password" error={this.props.error}>{this.context.t("Username")}:</InputLabel>
                            <Input
                                id="email"
                                value={this.state.email}
                                error={this.props.error}
                                onChange={this.handleChange('email')}
                                inputLabelProps={{
                                    style: {fontSize: 14},
                                    //shrink: true,
                                }}
                                inputProps={{
                                    style: {fontSize: 14},
                                    //shrink: true,
                                }}
                            />
                            </FormControl>
                    </CardContent>
                    <CardActions>
                        {
                            <Button
                                variant="contained"
                                type="submit"
                                color="primary"
                                disabled={this.props.recoverPassword_ == true}
                                className={classes.button}
                                onClick={this.submitHandler} 
                            >
                                {this.context.t("Submit")}
                            </Button>
                        }
                        {/* //changed */}
                        { <Button href="https://test.hkemc.com.hk"> {this.context.t("Back")}</Button> }
                    </CardActions>                
                </Card>
            </form>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        fullName: (state.caseInfo.userType !== null || state.caseInfo.userType !== undefined)  ? (state.caseInfo.userType === 'claimant' ? state.caseInfo.claimant_name : state.caseInfo.respondent_name) : '',
        password: state.userInfo.password,
        error: state.userInfo.error,
        isLoadingUpdate: state.userInfo.isLoadingUpdate,
        recoverPassword_: state.auth.recoverPassword,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        recoverPassword: (email) => dispatch(actions.recoverPassword(email)),
        resetRecoverPassword: () => dispatch(actions.resetRecoverPassword()),
    }
}

ForgetPasswordForm.contextTypes = {
    t: PropTypes.func,
  };

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(ForgetPasswordForm)));
